/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CasesList.module.scss'
import { useHistory } from 'react-router-dom'
import AddCaseView from './AddCaseView'
import CasesListTable from './CasesListTable'
import InfoDisplay from './InfoDisplay'
import BackAnchor from '../../../../shared/components/BackAnchor'

const CasesListView = ({ t, i18n, setIsError }) => {
  let history = useHistory()

  const onNextClick = () => {
    history.push(`/${i18n.language}${t('routes.contact_info')}`)
  }

  return (
    <div>
      <div className="container">
        <BackAnchor />
        <div className="row">
          <div className="col-xs-12">
            <h1>{t('title')}</h1>
          </div>
        </div>
        <InfoDisplay />
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <h2>{t('cases_list.review_the_details')}</h2>
            <CasesListTable setIsError={setIsError} />
          </div>
        </div>
        <div className="col-xs-12 col-md-8">
          <button
            className={['btn-lg btn-default', styles['next_button']].join(' ')}
            onClick={onNextClick}
            value={t('cases_list.next')}
            name={t('cases_list.next')}
          >
            {t('cases_list.next')}
          </button>
        </div>
        <div>
          <AddCaseView t={t} setIsError={setIsError} />
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(CasesListView)
